/**雷达图 */

import React from 'react';
import { Radar } from '@ant-design/charts';

import WidgetEchartConfig from './WidgetEchartConfig'

class WidgetEcharRadar extends React.Component
{
    constructor()
    {
        super();

        this.onEvent = this.onEvent.bind(this);
        this.buildConfig = this.buildConfig.bind(this);
    }

    /** event */
    onEvent(chart, event) 
    {
        if( this.props.onEvent!==undefined )
        {
            if( event.type==="element:mousedown" )
            {
                this.props.onEvent( event, event.data.data );
            } 
        } 
    }

    /** create config */
    buildConfig(option, data)
    {
        
        let yField = [];

        if( option.yField!==undefined)
        {
            for(let i in option.yField )
            {
                yField.push(option.yField[i].name)
            }
        }
        else
        {
            yField.push(...['value', 'value']);
        }

      var config = {
            appendPadding : 10,
            data: data.data,
            xField: option.xField!==undefined ? option.xField.name : 'name',
            yField: yField,
            layout: option.layout,
            xAxis : {
                line : null,
                tickLine : null,
                grid: {
                    line: {
                        style: {
                            lineDash: null,
                        },
                    },
                }
            },
            yAxis : {
                label : false,
                grid: {
                    line: {
                        type: 'line',
                        style: {
                            lineDash: null,
                        }
                    },
                    alternateColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        };

        if( option.theme!==undefined )
        {
            config = {...WidgetEchartConfig.theme[option.theme].radarConfig, ...option, ...config};
        }
        else
        {
            config = {...WidgetEchartConfig.theme["default"].radarConfig, ...option, ...config};
        }

        return config;
    }

    render()
    {
        const { option, data } = this.props; 
        
        let config = this.buildConfig(option, data);

        return <Radar {...config} />;
    }
}

export default WidgetEcharRadar;